<template>
  <div>
    <PageContainer>
      <PageHeader class="mb-6">
        <template v-slot:title>{{ pageTitle }}</template>
        <template v-if="existingUser" v-slot:subtitle>{{ userEmail }}</template>
        <template v-slot:actions>
          <v-btn
            color="secondary"
            :disabled="loading || saving"
            :loading="saving"
            @click="onSaveClicked"
          >
            <v-icon left>mdi-content-save</v-icon>
            Save
          </v-btn>
        </template>
      </PageHeader>

      <v-card v-if="!loading">
        <v-tabs vertical>
          <v-tab class="_overviewTab">
            <v-icon left>mdi-information-outline</v-icon>
            Overview
          </v-tab>
          <!-- <v-tab
                class="
                  d-flex
                  flex-column flex-md-row
                  justify-md-start justify-center
                "
              >
                <v-icon :left="verticalTabs">mdi-security</v-icon>
                Permissions
              </v-tab> -->
          <!-- <v-tab
                class="
                  d-flex
                  flex-column flex-md-row
                  justify-md-start justify-center
                "
              >
                <v-icon :left="verticalTabs">mdi-security</v-icon>
                Roles and Supplier
              </v-tab> -->
          <v-tab-item class="_overviewTabContent">
            <UserOverviewTab
              class="pa-4"
              :readonly="saving"
              :readonlyEmail="!newUser"
              :readonlyPassword="!newUser"
              :readonlyStatus="!newUser"
              :readonlyRole="!newUser"
              :user="user"
            />
          </v-tab-item>
          <!-- <v-tab-item>
                <user-permissions-tab
                  :selectedUser="user"
                ></user-permissions-tab>
              </v-tab-item> -->
          <!-- <v-tab-item>
                <SupplierTab :user="user" />
              </v-tab-item> -->
        </v-tabs>
      </v-card>
      <!-- <div class="d-flex justify-end" v-if="!isView">
        <v-btn
          :loading="isPerformingOperation"
          :disabled="isPerformingOperation"
          color="success"
          large
          @click="AddUser()"
          >Save</v-btn
        >
      </div> -->
    </PageContainer>
  </div>
</template>

<script>
import UserOverviewTab from "./UserDetailsOverviewTab.vue";
import api from "../../../../api";
import toasts from "../../../../utils/toasts";
import { navigation } from "../../../../router";
export default {
  components: {
    UserOverviewTab,
  }, // components
  data() {
    return {
      loading: false,
      saving: false,
      user: {},
      isEdit: false,
      isView: false,
      isAdd: false,
      isPerformingOperation: false,
      verticalTabs: true,
    };
  }, // data
  computed: {
    existingUser() {
      return this.userId != null;
    },
    pageTitle() {
      return this.existingUser ? "User Details" : "New User";
    },
    newUser() {
      return this.userId == null;
    },
    userEmail() {
      return this.user.email;
    },
    userId() {
      return this.$route.params.id;
    },
  }, // computed
  mounted() {
    if (this.existingUser) this.loadUserAsync();

    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.verticalTabs = window.innerWidth >= 960;
      });
    });

    this.verticalTabs = window.innerWidth >= 960;
  },
  methods: {
    onSaveClicked() {
      this.saveUserAsync();
    },
    async loadUserAsync() {
      this.loading = true;
      this.user = await api.users.getById(this.userId);
      this.loading = false;
    },
    async saveUserAsync() {
      if (this.newUser) {
        this.saving = true;
        try {
          const createdUser = await api.users.signUpWithEmailAsync({
            email: this.user.email,
            password: this.user.guiPassword,
            passwordConfirm: this.user.guiPassword,
            roleName: this.user.role.roleName,
            supplierInternalId: this.user.supplierInternalId,
            suppliers: this.user.suppliers,
          });
          const route = navigation.main.users.details(createdUser.userId);
          this.$router.replace(route);
          toasts.success("Successfully created user");
        } finally {
          this.saving = false;
        }
      } else if (this.existingUser) {
        this.saving = true;
        try {
          await api.users.updateAsync(this.userId, this.user);
          toasts.success("Successfully updated user");
        } finally {
          this.saving = false;
        }
      }
    },
  },
};
</script>

<style>
</style>